export default function (initialDataInteractor, instanceIdentifier) {
  initialDataInteractor.data.people.forEach(function (person) {
    if (person.questionnaire_instances) {
      person.questionnaire_instances.forEach(function (instance, index) {
        if (instance.identifier == instanceIdentifier) {
          person.questionnaire_instances.splice(index, 1);
        }
      })
    }
  });
}